import { render, staticRenderFns } from "./OnlineCourse.vue?vue&type=template&id=b7dfe426&scoped=true"
import script from "./OnlineCourse.vue?vue&type=script&lang=js"
export * from "./OnlineCourse.vue?vue&type=script&lang=js"
import style0 from "./OnlineCourse.vue?vue&type=style&index=0&id=b7dfe426&prod&lang=scss&scoped=true"
import style1 from "./OnlineCourse.vue?vue&type=style&index=1&id=b7dfe426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dfe426",
  null
  
)

export default component.exports